import { FlowGetSftpFileBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const GetSftpFileBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GetSftpFile),
  config: FlowGetSftpFileBlockConfigSchema,
});

export type GetSftpFileBlock = z.infer<typeof GetSftpFileBlockSchema>;
